import { useState } from "react";
import "./doyenAccessOfferings.css";

const Offerings = ({
  showbasic,
  showintermediate,
  showprofessional,
  goToAccessRegistration,
  prices,
  currency,
  oldPrices,
}: {
  showbasic: boolean;
  showintermediate: boolean;
  showprofessional: boolean;
  goToAccessRegistration: (id: string) => void;
  prices: { Basic: number; Intermediate: number; Professional: number };
  oldPrices: { Basic: number; Intermediate: number; Professional: number };
  currency: string;
}) => {
  const [activeService, setAtiveService] = useState<
    "basic" | "intermediate" | "professional"
  >("intermediate");

  return (
    <div
      className="bg-[#F7F7F7] p-[40px] sm:p-6 sm:pl-2 mt-[104px] sm:w-[140vw]"
      id="paymentaccess"
    >
      <div className="mx-auto text-center w-[570px] sm:w-[136vw]">
        <h1 className="text-[24px] font-bold text-[#222222]">
          Our Exclusive Membership Offering
        </h1>
        <p className="text-[#636363] sm:text-[14px] sm:text-center ">
          Elevate your journey with our exclusive subscription plans. Experience
          personalized support and unlock a world of opportunities tailored just
          for you
        </p>
      </div>
      <div className="container">
        <div className="row flex md:flex-col ">
          <div className=" offerings sm:mb-4 md:mb-4 ">
            <div
              className={`relative ${
                activeService === "basic" ? "bg-[#DEFFE2]" : "bg-white"
              } h-[520px] rounded-2xl p-[40px] flex flex-col items-center `}
              onClick={() => setAtiveService("basic")}
            >
              <div className="w-full flex justify-between">
                <img src="/images/doyen_access/basic_icon.svg" alt="layers" />

                <p className="bg-[#DEFFE2] text-[#367E3E] w-[122px] rounded-full font-bold text-center h-[36px] pt-[6px]">
                  Basic Access
                </p>
              </div>
              <div
                className={`flex gap-2 ${
                  currency === "NGN"
                    ? "xl:ml-[2em] items-center"
                    : "xl:ml-[6em] items-end "
                } mt-[16px]`}
              >
                <h5
                  className={`line-through text-[#636363] ${
                    currency === "NGN" ? "text-[16px]" : "text-[28px]"
                  } `}
                >
                  {/* €130 */}
                  {currency}
                  {oldPrices.Basic}
                  {currency === "NGN" ? "k" : ""}
                </h5>
                {/* €110 */}
                <h5
                  className={`${
                    currency === "NGN" ? "text-[21px]" : "text-[28px]"
                  } font-bold`}
                >
                  {currency}
                  {prices.Basic}
                  {currency === "NGN" ? "k" : ""}
                </h5>
                <p className="text-[14px] text-[#222222]">/ Per month</p>
              </div>

              <p
                className={` text-[#636363] w-[320px]${
                  currency === "NGN" ? " mt-[20px] " : " mt-[24px] "
                } offerings_lists`}
              >
                <li>
                  Career advice and direction sessions (1 hour 15 minutes per
                  week).
                </li>
                <li>Participate in all webinars and workshops.</li>
                <li>Internship opportunities with Doyenify.</li>
              </p>

              <button
                className={`${
                  currency === "NGN" ? "mt-[150px]" : "mt-[130px]"
                } text-white bg-[#367E3E] rounded-full w-[150px] flex py-2 text-center gap-2 pl-4`}
                onClick={() => {
                  goToAccessRegistration("basicaccess");
                }}
              >
                Get Access
                <img src="/images/doyen_access/arrow.png" alt="" />
              </button>
            </div>
          </div>
          <div className=" offerings sm:mb-4 md:mb-4">
            <div
              className={`relative ${
                activeService === "intermediate" ? "bg-[#DEFFE2]" : "bg-white"
              } h-[520px] rounded-2xl p-[40px] flex flex-col items-center`}
              onClick={() => setAtiveService("intermediate")}
            >
              <div className="w-full flex justify-between">
                <img
                  src="./images/doyen_access/intermediate_icon.svg"
                  alt="layers"
                />

                <p className="bg-[#DEFFE2] text-[#367E3E] w-[179px] rounded-full font-bold text-center h-[36px] pt-[6px]">
                  Intermediate Access
                </p>
              </div>
              <div
                className={`flex gap-2 ${
                  currency === "NGN"
                    ? "xl:ml-[2em] items-center"
                    : "xl:ml-[6em] items-end "
                } mt-[16px]`}
              >
                <h5
                  className={`line-through text-[#636363] ${
                    currency === "NGN" ? "text-[16px]" : "text-[28px]"
                  } `}
                >
                  {/* €220 */}
                  {currency}
                  {oldPrices.Intermediate}
                  {currency === "NGN" ? "k" : ""}
                </h5>
                {/* €180 */}
                <h5
                  className={`${
                    currency === "NGN" ? "text-[21px]" : "text-[28px]"
                  } font-bold`}
                >
                  {currency}
                  {prices.Intermediate}
                  {currency === "NGN" ? "k" : ""}
                </h5>
                <p className="text-[14px] text-[#222222]">/ Per month</p>
              </div>

              <p
                className={` text-[#636363] w-[320px]${
                  currency === "NGN" ? " mt-[20px] " : " mt-[24px] "
                } offerings_lists`}
              >
                <li>
                  All features from Basic Access Career advice and direction
                  sessions (2 hours 30 mins per week).
                </li>
                <li>
                  Priority access to career advice and direction sessions.
                </li>
                <li>
                  Hands-on support with subscribers' professional challenges.
                </li>
                <li>
                  Enhanced internship opportunities with direct mentorship
                </li>
              </p>
              <button
                className={`${
                  currency === "NGN" ? "mt-[55px]" : "mt-[60px]"
                } text-white bg-[#367E3E] rounded-full w-[150px] flex py-2 text-center gap-2 pl-4`}
                onClick={() => {
                  goToAccessRegistration("intermediateaccess");
                }}
              >
                Get Access
                <img src="/images/doyen_access/arrow.png" alt="" />
              </button>
            </div>
          </div>
          <div className=" offerings sm:mb-4 md:mb-4">
            <div
              className={`relative ${
                activeService === "professional" ? "bg-[#DEFFE2]" : "bg-white"
              } h-[520px] rounded-2xl p-[40px] flex flex-col items-center`}
              onClick={() => setAtiveService("professional")}
            >
              <div className="w-full flex justify-between">
                <img
                  src="/images/doyen_access/professional-icon.svg"
                  alt="layers"
                />

                <p className="bg-[#DEFFE2] text-[#367E3E] w-[174px] rounded-full font-bold text-center h-[36px] pt-[6px]">
                  Professional Access
                </p>
              </div>
              <div
                className={`flex gap-2 ${
                  currency === "NGN"
                    ? "xl:ml-[2em] items-center"
                    : "xl:ml-[6em] items-end "
                } mt-[16px]`}
              >
                <h5
                  className={`line-through text-[#636363] ${
                    currency === "NGN" ? "text-[16px]" : "text-[28px]"
                  } `}
                >
                  {/* €310 */}
                  {currency}
                  {oldPrices.Professional}
                  {currency === "NGN" ? "k" : ""}
                </h5>
                {/* €250 */}
                <h5
                  className={`${
                    currency === "NGN" ? "text-[21px]" : "text-[28px]"
                  } font-bold`}
                >
                  {currency}
                  {prices.Professional}
                  {currency === "NGN" ? "k" : ""}
                </h5>
                <p className="text-[14px] text-[#222222]">/ Per month</p>
              </div>

              <p
                className={` text-[#636363] w-[320px]${
                  currency === "NGN" ? " mt-[20px] " : " mt-[24px] "
                } offerings_lists`}
              >
                <li>
                  All features from Intermediate Access Career advice and
                  direction sessions (4 hours per week).
                </li>
                <li>
                  In-depth sessions on industry standards and best practices.
                </li>
                <li>
                  A personalized, one-on-one programming mentoring session
                  tailored to your preferred programming language.
                </li>
                <li>
                  Exclusive insights into industry trade secrets and strategies.
                </li>
                <li>
                  Expanded networking opportunities with direct connections to
                  industry experts.
                </li>
              </p>
              <button
                className={`${
                  currency === "NGN" ? "mt-[-15px]" : "mt-[-10px]"
                } text-white bg-[#367E3E] rounded-full w-[150px] flex py-2 text-center gap-2 pl-4`}
                onClick={() => {
                  goToAccessRegistration("professionalaccess");
                }}
              >
                Get Access
                <img src="/images/doyen_access/arrow.png" alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Offerings;
